import { combineReducers } from '@reduxjs/toolkit';
import scorecards, { ScoreCardsState } from './ScoreCardsReducer';
import defaultValues from './DefaultValuesReducer';
import xmlHeaders from './XmlHeadersReducer';
import companyProfile, { CompanyProfileState } from './CompanyProfileReducer';
import brandCustomData, { BrandCustomDataState } from './BrandCustomDataReducer';

export type SettingsState = {
  scorecards: ScoreCardsState;
  defaultValues: any;
  companyProfile: CompanyProfileState;
  xmlHeaders: any;
  brandCustomData: BrandCustomDataState;
};
const SettingsReducer = combineReducers({
  scorecards,
  defaultValues,
  xmlHeaders,
  companyProfile,
  brandCustomData,
});

export default SettingsReducer;
